import React from "react";
import { FormEnabler, ValidatedForm, MInput, MSelect } from "components/forms";
import { payloadBuilder, networkErrorHelper, lessonSectionService } from "libs";
import { BoxInfo, BoxSuccess } from "components/misc";

export class AdminLessonResumeForm extends ValidatedForm {
  ERROR_MESSAGES = {
    section: "Sezione obbligatoria",
    lessonId: "Lezione obbligatoria",
    minutes: "Minuti obbligatori",
  };

  PAYLOADS = {
    sections: [{ label: "Seleziona una sezione", value: "" }],
    lessons: [{ label: "Seleziona una lezione", value: "" }],
  };

  emptyFields = {
    section: "",
    lessonId: "",
    minutes: "",
  };

  validation = {
    section: (value) => value !== "" && value !== null,
    lessonId: (value) => value !== "" && value !== null,
    minutes: (value) => value !== "" && !isNaN(parseInt(value)) && parseInt(value) > 0,
  };

  FIELDS_GROUP = [
    [
      {
        id: "section",
        field: "section",
        label: "Sezione",
        component: MSelect,
        payload: { options: this.PAYLOADS.sections },
        className: "col-md-12",
        onChange: (id, value) => this.onSectionChange(id, value),
      },
    ],
    [
      {
        id: "lessonId",
        field: "lessonId",
        label: "Lezione",
        component: MSelect,
        payload: { options: this.PAYLOADS.lessons },
        className: "col-md-12",
      },
    ],
    [
      {
        id: "minutes",
        field: "minutes",
        label: "Minuti recuperati",
        component: MInput,
        type: "number",
        className: "col-md-8",
      },
    ],
  ];

  //--- ---

  constructor(props) {
    super(props);

    this.state = {
      ...this.emptyFields,
      defaultValues: { ...this.emptyFields },
      formActive: true,
      rndKey: 0,
      missingMinutes: null,
    };
  }

  componentDidMount() {
    this.loadRemoteSections();
  }

  getLessonType = (type) => {
    switch (type) {
      case "live":
        return "Online";
      case "onsite":
        return "In presenza";
      case "training":
        return "Tirocinio";
      default:
        return type;
    }
  };

  loadRemoteSections() {
    const { aa, courseType } = this.props;
    if (!courseType) return;

    lessonSectionService
      .getSectionsByCourseType(courseType, aa)
      .then(({ data }) => {
        this.PAYLOADS.sections.length = 1;

        data.payload.sections.forEach((s) => {
          this.PAYLOADS.sections.push({ label: `${s.code} - ${s.title}`, value: s.code, totalMinutes: s.totalMinutes });
        });

        this.setState({ rndKey: Math.floor(Math.random() * 1000 + 1) });
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
      });
  }

  loadRemoteLessons(section) {
    const { aa, courseCode } = this.props;
    this.PAYLOADS.lessons.length = 1;

    if (!section) {
      this.setState({ rndKey: Math.floor(Math.random() * 1000 + 1) });
      return;
    }

    lessonSectionService
      .getLessonsBySection(section, courseCode, aa)
      .then(({ data }) => {
        data.payload.lessons.forEach((l) => {
          this.PAYLOADS.lessons.push({
            label: `${this.getLessonType(l.lessonType)} ${l.mode ? l.mode : ""} - ${l.description}  ${l.hourStart && l.hourEnd ? `(${l.hourStart.substring(0, l.hourStart.length - 3)} - ${l.hourEnd.substring(0, l.hourEnd.length - 3)})` : ""}`,
            value: l.id,
            lessonType: l.lessonType,
            mode: l.mode,
          });
        });

        this.setState({ rndKey: Math.floor(Math.random() * 1000 + 1) });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
      });
  }

  loadMissingMinutes(section) {
    const { registrationCode } = this.props;
    if (!section || !registrationCode) return;

    const selectedSection = this.PAYLOADS.sections.find((s) => s.value === section);
    const totalMinutes = selectedSection.totalMinutes || 0;

    lessonSectionService
      .getAnalyticsStudentSection(registrationCode)
      .then(({ data }) => {
        const { analytics } = data.payload;
        const sectionData = analytics.find((s) => s.section === section);

        const attendedMinutes = sectionData ? sectionData.minutes : 0;
        const missing = totalMinutes - attendedMinutes;

        if (missing > 0) {
          this.setState({
            missingMinutes: (
              <BoxInfo>
                Minuti mancanti per questa sezione: <strong>{missing}</strong>
              </BoxInfo>
            ),
          });
        } else if (missing <= 0 && totalMinutes > 0) {
          this.setState({
            missingMinutes: (
              <BoxSuccess>
                <strong>Sezione già al 100%</strong>
              </BoxSuccess>
            ),
          });
        } else {
          this.setState({ missingMinutes: null });
        }
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
      });
  }

  onSectionChange = (_, value) => {
    this.setState({ lessonId: "" });
    this.loadRemoteLessons(value);
    this.loadMissingMinutes(value);
  };

  onCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
      this.resetForm();
    } else {
      this.resetForm();
    }
  };

  onSubmit = (e) => {
    if (e) e.preventDefault();
    if (!this.checkValidation()) return;

    this.saveRemote();
  };

  saveRemote = () => {
    const { userId, email, registrationCode, analyticsType } = this.props;
    const payload = payloadBuilder(this.state);

    payload.lessonId = parseInt(payload.lessonId);
    payload.userId = userId;
    payload.email = email;
    payload.registrationCode = registrationCode;
    payload.analyticsType = analyticsType;

    const selectedLesson = this.PAYLOADS.lessons.find((l) => l.value === payload.lessonId);
    if (selectedLesson) {
      payload.lessonType = selectedLesson.lessonType;
      payload.mode = selectedLesson.mode;
    }

    lessonSectionService
      .insertRecoveryResume(payload)
      .then(() => {
        if (this.props.onSuccess) {
          this.props.onSuccess();
        }
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  };

  //--- ---

  render() {
    let { formActive, defaultValues, rndKey, missingMinutes } = this.state;

    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, formActive);

    return (
      <div key={rndKey} className="p-2">
        <form className="user">
          {code}
          {missingMinutes}
        </form>

        <div className="mt-4">
          <FormEnabler onSubmit={this.onSubmit} onCancel={this.onCancel} onToggle={this.toggleForm} isFormActive={formActive} />
        </div>
      </div>
    );
  }
}
